// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__TjdNQ","inputWrap":"CustomTip_inputWrap__37mZm"};